import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import api from "../../util/api";

export const getVideoData = createAsyncThunk("review/getVideoData", async id => {
    const response = await api.get(`/review/${id}`);
    return {videoReviewData: response.data};
});

export const editVideoData = createAsyncThunk("review/editVideoData", async ({id, fieldToChange}, {getState}) => {
    const response = await api.put(`/api/videos/${id}`, {
        ...fieldToChange,
    });

    const {
        data: {data = [], message = [{}]},
    } = response;

    const state = getState();
    const oldData = state.reviewNew.videoReviewData.videoReviewData;
    const newData = oldData.map(comp => (comp.id === data.id ? data : comp));

    if (message[0].text) {
        return {videoReviewData: oldData, error: message[0].text};
    }

    return {videoReviewData: newData};
});

export const deleteMediaItem = createAsyncThunk("review/deleteMediaItem", async ({videoId, onSuccess, onError}) => {
    return await api
        .delete(`/api/videos/${videoId}`)
        .then(response => {
            onSuccess();
            return response.data;
        })
        .catch(err => {
            onError();
            return err;
        });
});
export const getVideoBadges = createAsyncThunk("review/getVideoBadges", async id => {
    const response = await api.get(`/review/${id}/badges`);
    return {videoBadges: response.data};
});

export const toggleVideoBadges = createAsyncThunk("review/toggleVideoBadges", async ({videoId, badge}) => {
    const response = await api.put(`/v2/api/review/${videoId}/feature/${badge.id}/${badge.person_id}/toggle`, {});

    return {videoBadges: response.data};
});

const initialState = {
    videoReviewData: {
        videoReviewData: {},
        status: {
            type: "idle",
            error: null,
        },
    },
    videoBadges: {
        videoBadges: {},
        status: {
            type: "idle",
            error: null,
        },
    },
    peopleDropdown: {
        peopleDropdown: [],
        status: {
            type: "idle",
            error: null,
        },
    },
};

const reviewPageSlice = createSlice({
    name: "review",
    initialState,
    reducers: {
        setInitialState: state => initialState,
    },
    extraReducers: {
        // COMPONENTS:
        //get video info:
        [getVideoData.pending]: ({videoReviewData}, action) => {
            videoReviewData.status.type = "loading";
        },
        [getVideoData.fulfilled]: ({videoReviewData}, action) => {
            videoReviewData.status.type = "succeeded";
            videoReviewData.videoReviewData = action.payload.videoReviewData;
        },
        [getVideoData.rejected]: ({videoReviewData}, action) => {
            videoReviewData.status.type = "failed";
            videoReviewData.status.error = action.error.message;
        },

        //edit video info:
        [editVideoData.pending]: ({videoReviewData}, action) => {
            videoReviewData.status.type = "loading";
        },
        [editVideoData.fulfilled]: ({videoReviewData}, action) => {
            videoReviewData.status.type = "succeeded";

            videoReviewData.status.error = action.payload.error || "";
            videoReviewData.videoReviewData = action.payload.videoReviewData;
        },
        [editVideoData.rejected]: ({videoReviewData}, action) => {
            videoReviewData.status.type = "failed";
            videoReviewData.status.error = action.error.message;
        },

        //delete video:

        [deleteMediaItem.pending]: ({videoReviewData}, action) => {
            videoReviewData.status.type = "loading";
        },
        [deleteMediaItem.fulfilled]: ({videoReviewData}, action) => {
            videoReviewData.status.type = "succeeded";
        },
        [deleteMediaItem.rejected]: ({videoReviewData}, action) => {
            videoReviewData.status.type = "failed";
            videoReviewData.status.error = action.error.message;
        },

        //Badges:
        //get badges:
        [getVideoBadges.pending]: ({videoBadges}, action) => {
            videoBadges.status.type = "loading";
        },
        [getVideoBadges.fulfilled]: ({videoBadges}, action) => {
            videoBadges.typesStatus.type = "succeeded";
            videoBadges.types = action.payload.data;
        },
        [getVideoBadges.rejected]: ({videoBadges}, action) => {
            videoBadges.typesStatus.type = "failed";
            videoBadges.typesStatus.error = action.error.message;
        },

        //toggle badge:
        [toggleVideoBadges.pending]: ({videoBadges}, action) => {
            videoBadges.status.type = "loading";
        },
        [toggleVideoBadges.fulfilled]: ({videoBadges}, action) => {
            videoBadges.status.type = "succeeded";

            videoBadges.status.error = action.payload.error || "";
            videoBadges.videoBadges = action.payload.videoBadges;
        },
        [toggleVideoBadges.rejected]: ({videoBadges}, action) => {
            videoBadges.status.type = "failed";
            videoBadges.status.error = action.error.message;
        },
    },
});

export const {setInitialState} = reviewPageSlice.actions;
export default reviewPageSlice.reducer;

export const selectVideoInfo = state => state.reviewNew.videoReviewData.videoReviewData;
export const selectVideoStatus = state => state.reviewNew.homepageSettings.status;

export const selectAllBadges = state => state.reviewNew.videoBadges.videoBadges;
export const selectBadgesStatus = state => state.reviewNew.videoBadges.status;
